import { publish } from './pubsub';
import { PUB_SUB_EVENTS } from './constants';

export function addToCartButtons() {
  // Use JS API for /cart page
  const path = window.location.pathname.replace(/\/$/, '');
  if (path == '/cart') {
    const buttons = document.querySelectorAll<HTMLButtonElement>('.js-add-to-cart');
    buttons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) {
          return;
        }
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
          }),
        })
          .then((res) => res.json())
          .then((_data) => {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-products', variantId: Number(variantId) });
          })
          .catch((_err) => {
            // Optionally show a UI error here
          })
          .finally(() => {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          });
      });
    });
  }

  const selects = document.querySelectorAll<HTMLSelectElement>('.js-select-options');
  selects.forEach(function (select) {
    select.addEventListener('change', function () {
      const variantId = select.value;
      if (!variantId) return;
      const card = select.closest('article');
      if (!card) return;

      const addToCartBtn = card.querySelector<HTMLButtonElement>('.js-add-to-cart');
      const variantIdInput = card.querySelector<HTMLFormElement>('input[type="hidden"][name="id"]');

      if (variantIdInput) {
        variantIdInput.value = variantId;
      }
      if (addToCartBtn) {
        addToCartBtn.setAttribute('data-variant-id', variantId);
      }

      // Update price and compare-at-price
      const selectedOption = select.options[select.selectedIndex];
      const price = selectedOption.getAttribute('data-price') || '';
      const compareAtPrice = selectedOption.getAttribute('data-compare-at-price') || '';
      const priceEl = card.querySelector<HTMLElement>('.js-variant-price');
      const compareAtPriceEl = card.querySelector<HTMLElement>('.js-variant-compare-at-price');
      const badgeEl = card.querySelector<HTMLElement>('.js-variant-badge');

      if (priceEl) {
        priceEl.textContent = price;
      }
      if (compareAtPriceEl) {
        compareAtPriceEl.textContent = compareAtPrice;
      }
      if (badgeEl) {
        if (compareAtPrice && compareAtPrice !== price) {
          badgeEl.classList.add('badge-discount');
        } else {
          badgeEl.classList.remove('badge-discount');
        }
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  addToCartButtons();
});
